import { ReactNode, useState } from 'react';
import CollapsibleSection, { CollapsibleProps } from 'components/collapsible/collapsible-section';

type CollapsibleItem = {
  title: ReactNode;
  children: ReactNode;
};

type HoverCollapsibleProps = {
  items: readonly CollapsibleItem[];
  showNumbers?: boolean;
} & Omit<CollapsibleProps, 'title' | 'children' | 'isActive' | 'onClick'>;

export default function HoverCollapsibleSection({ items, showNumbers = false, ...props }: HoverCollapsibleProps) {
  const [activeItems, setActiveItems] = useState<number[]>([]);

  const handleClick = (index: number) => {
    setActiveItems(prev => {
      if (prev.includes(index)) {
        return prev.filter(i => i !== index);
      }
      return [...prev, index];
    });
  };

  return (
    <div>
      {items.map((item, index) => (
        <CollapsibleSection
          key={index}
          title={item.title}
          isActive={activeItems.includes(index)}
          onClick={() => handleClick(index)}
          showNumbers={showNumbers}
          itemIndex={index}
          {...props}
        >
          {item.children}
        </CollapsibleSection>
      ))}
    </div>
  );
}
